export const environment = {
  production: true,
  datasourceUrls: {
    aprendeSso: 'https://cuentas-stg0.aprende.org',
    catalogs: 'https://catalogos.aprende.org',
  },
};
